import {
    Component,
    ComponentInterface,
    Element,
    h,
    Host,
    Prop,
} from "@stencil/core";
import {
    FilterDataProvider,
    FilterDataProviderState,
    getFilterDataProvider,
} from "../../apis/stateful-content";

@Component({
    tag: "ux-iws-stateful-filter-search",
    styleUrl: "stateful-filter-search.scss",
    shadow: false,
})
export class StatefulFilterSearch implements ComponentInterface {
    private baseClass = "ux-iws-stateful-filter-search";
    private filterProvider: FilterDataProvider;
    private input: HTMLUxInputFieldElement;

    @Element() domNode: HTMLUxIwsStatefulFilterSearchElement;

    /** print debug info */
    @Prop() debug: boolean = false;
    /** scope used to retrieve the filter data provider */
    @Prop() scope: string = "";
    /** Placeholder for search input */
    @Prop() placeholder: string = "";
    /** name attribute for the input */
    @Prop() name: string = "";

    private _log = (...args: any[]) => {
        if (this.debug && console && typeof console.log === "function") {
            console.log(`[Stateful-Filter-Search]:`, ...args);
        }
    };

    componentWillLoad() {
        this.filterProvider = getFilterDataProvider(this.scope);
        this.filterProvider.subscribe(this.handleFilterProviderState);
        this.filterProvider.getData();
    }

    componentDidLoad(): void {
        this.filterProvider.filterQuery.split("&").forEach((query) => {
            if (query.startsWith(`${this.name}=`)) {
                this.input.value = query.split("=")[1];
            }
        });
    }

    private handleFilterProviderState = ({
        filterData,
        filterQuery,
    }: FilterDataProviderState) => {
        if (filterData === null) {
            return;
        }
        this._log(`handleFilterProviderState filterQuery: "${filterQuery}"`);
        if (filterQuery === "" && this.input.value !== "") {
            this.input.value = "";
        }
    };

    private handleSubmit = (event: Event) => {
        event.preventDefault();
        const formData = new FormData(event.target as HTMLFormElement);
        const searchValue = formData.get(this.name) as string;
        this._log(`searchValue: "${searchValue}"`);

        this.filterProvider.setFilterQuery(this.buildFilterQuery(searchValue));
    };

    private buildFilterQuery = (searchValue: string) => {
        const filterQueries = this.filterProvider.filterQuery.split("&");
        const searchQueries =
            searchValue === "" ? [] : [`${this.name}=${searchValue}`];
        return [
            ...filterQueries.filter((query) => {
                return !query.startsWith(`${this.name}=`) && query !== "";
            }),
            ...searchQueries,
        ].join("&");
    };

    private handleChange = () => {
        this._log(`handleChange: "${this.input.value}"`);
        if (this.input.value === "" && this.filterProvider.filterQuery !== "") {
            this.filterProvider.setFilterQuery(this.buildFilterQuery(""));
        }
    };

    render() {
        return (
            <Host class={this.baseClass}>
                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <ux-input-field
                        ref={(el: HTMLUxInputFieldElement) => (this.input = el)}
                        clearable
                        name={this.name}
                        type="text"
                        placeholder={this.placeholder}
                        onUxChange={() => this.handleChange()}
                    ></ux-input-field>
                    <button
                        class="ux-button ux-button--primary ux-button--icon-only"
                        type="submit"
                    >
                        <ux-icon name="magnifier"></ux-icon>
                    </button>
                </form>
            </Host>
        );
    }
}
